module.exports = __webpack_public_path__ + "img/kayak.ef87cf1.jpg";